// extracted by mini-css-extract-plugin
export var documentation = "_lq-1";
export var menu = "_lq-0";